import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import LengthLimitedTextField from "../../../common/components/LengthLimitedTextField"
import DialogHeader from "../components/DialogHeader"
import { getStageNameError } from "./utils"

export default function AddStageDialog({ open, onClose, existingStages }) {
  const [name, setName] = useState("")
  const [isCreating, setIsCreating] = useState(false)
  const axios = useAuthorizedAxiosClient()

  const nameError = getStageNameError(existingStages, name)

  function handleCreateButtonClicked() {
    setIsCreating(true)
    axios
      .post(`/crm/api/crm-stages/`, { name })
      .then(({ data }) => {
        onClose(data)
        setName("")
      })
      .finally(() => setIsCreating(false))
  }

  function handleSoftClose() {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Add Hiring Stage" onClose={handleSoftClose} />
      <DialogContent>
        <LengthLimitedTextField
          label="Stage Name"
          required
          value={name}
          setValue={setName}
          error={!!nameError}
          helperText={nameError}
          maxLength={64}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isCreating}
          disabled={name.length === 0 || !!nameError}
          onClick={handleCreateButtonClicked}
        >
          Create
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
